import { request } from '../../lib/request_member';
import { filterHiddenTenants } from '../npgw/cms/tenant_config';
// 等级列表
export function getlevelList(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberLevel/findList',
        method: 'get',
        params,
    });
}
//添加等级
export function addLevel(data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberLevel/add',
        method: 'post',
        dataType: 'json',
        data,
    });
}
//编辑等级
export function updateLevel(data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberLevel/update',
        method: 'post',
        dataType: 'json',
        data,
    });
}
//获取详情
export function getById(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberLevel/getById',
        method: 'get',
        params,
    });
}
//删除等级
export function deleteLevel(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberLevel/deleteById',
        method: 'get',
        params,
    });
}
//校验等级名称去重
export function getUniqueStatusForName(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberLevel/getByName',
        method: 'get',
        params,
    });
}
//会员自定义列表
export function getMemberFormItemList(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberFormItem/getMemberFormItemList',
        method: 'get',
        params,
    });
}
//自定义项新增
export function getMemberFormItemAdd(params,data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberFormItem/add',
        method: 'post',
        dataType: 'json',
        params,
        data,
    });
}
//查询自定义项详情
export function getMemberFormById(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberFormItem/get',
        method: 'get',
        params,
    });
}
//删除自定义数据
export function getMemberFormDelete(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberFormItem/delete',
        method: 'get',
        params,
    });
}
//改变开关状态快捷接口
export function getMemberFormOperation(params,data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberFormItem/operation',
        method: 'post',
        dataType: 'json',
        params,
        data,
    });
}
//自定义项新增
export function getMemberFormItemEdit(params,data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberFormItem/edit',
        method: 'post',
        dataType: 'json',
        params,
        data,
    });
}
//会员列表
export function memberFindPage(params,data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/findPage',
        method: 'post',
        dataType: 'json',
        params,
        data,
    });
}
//机构列表
export function findOrgPage(params, data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/findOrgPage',
        method: 'post',
        dataType: 'json',
        params,
        data,
    });
}
//按门户身份统计个人会员：注册人数 + 近N天活跃人数（有登录）
export function countPersonalMemberByPortalIdentity(data) {
    return request({
        url: '{#npgw}/mwebapi/member/portal/countPersonalMemberByPortalIdentity',
        method: 'post',
        dataType: 'json',
        data,
    });
}
//客户列表
export function findClientPage(params,data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/findClientPage',
        method: 'post',
        dataType: 'json',
        params,
        data,
    });
}
//启用停用会员
export function memberOperation(data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/operation',
        method: 'post',
        dataType: 'json',
        data,
    });
}
//批量停用启用
export function memberBatchOperation(params,data, logObj) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/batchOperation',
        method: 'post',
        dataType: 'json',
        params,
        data,
        logObj,
        logFlag: {
            appName: '会员管理',
            operModule: '修改会员状态（停启用）',
        },
    });
}
//删除会员
export function memberDelete(params, logObj) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/delete',
        method: 'get',
        params,
        logObj,
        logFlag: {
            appName: '会员管理',
            operModule: '删除会员',
        },
    });
}
//会员审核
export function memberAudit(params,data, logObj) {
    return request({
        url: '{#npgw}/mwebapi/member/memberAudititingInfo/audit',
        method: 'post',
        dataType: 'json',
        params,
        data,
        logObj,
        logFlag: {
            appName: '会员管理',
            operModule: '会员审核',
        },
    });
}
//检查数据项是否被引用
export function checkRefrenceItem(params,data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberFormItem/checkRefrenceItem',
        method: 'post',
        dataType: 'json',
        params,
        data,
    });
}
//转移等级分组
export function memberMove(params,data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/move',
        method: 'post',
        dataType: 'json',
        params,
        data,
    });
}
//查看会员详情
export function memberGet(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/get',
        method: 'get',
        params,
    });
}
// 分组列表
export function getGroupList(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberGroup/findList',
        method: 'get',
        params,
        timeout: 60000,
    });
}
//添加分组
export function addGroup(data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberGroup/add',
        method: 'post',
        dataType: 'json',
        data,
    });
}
//编辑分组
export function updateGroup(data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberGroup/update',
        method: 'post',
        dataType: 'json',
        data,
    });
}
//获取分组详情
export function getGroupById(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberGroup/getById',
        method: 'get',
        params,
    });
}
//删除分组
export function deleteGroup(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberGroup/deleteById',
        method: 'get',
        params,
    });
}
//校验分组名称去重
export function getGroupUniqueStatusForName(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberGroup/getByName',
        method: 'get',
        params,
    });
}
// 新增会员
export function addM(params,data, logObj) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/add',
        method: 'post',
        dataType: 'json',
        params,
        data,
        logObj,
        logFlag: {
            appName: '会员管理',
            operModule: '添加会员',
        },
    });
}
// 编辑更新会员
export function editM(params,data, logObj) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/edit',
        method: 'post',
        dataType: 'json',
        params,
        data,
        logObj,
        logFlag: {
            appName: '会员管理',
            operModule: '编辑会员',
        },
    });
}
export function toMember(params, data, logObj) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/toMember',
        method: 'post',
        dataType: 'json',
        params,
        data,
        logObj,
        logFlag: {
            appName: '会员管理',
            operModule: '编辑会员',
        },
    });
} 
//查询注册协议
export function memberRegisterProtocalGet(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberRegisterProtocal/get',
        method: 'get',
        params,
    });
}
//修改注册协议
export function memberRegisterProtocalEdit(params,data, logObj) {
    return request({
        url: '{#npgw}/mwebapi/member/memberRegisterProtocal/edit',
        method: 'post',
        params,
        data,
        dataType: 'json',
        logObj,
        logFlag: {
            appName: '会员管理',
            operModule: '修改注册协议',
        },
    });
}
// 重置密码
export function resetPwd(params,data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/resetPwd',
        method: 'post',
        dataType: 'json',
        params,
        data,
    });
}
//恢复默认
export function memberRegisterProtocalRestore(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberRegisterProtocal/restore',
        method: 'get',
        params,
    });
}
//查询高级设置
export function getByDataKeys(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberSystemSetting/getByDataKeys',
        method: 'get',
        params,
    });
}
//编辑系统设置
export function memberSystemSettingEdit(params,data, logObj) {
    return request({
        url: '{#npgw}/mwebapi/member/memberSystemSetting/edit',
        method: 'post',
        dataType: 'json',
        params,
        data,
        logObj,
        logFlag: {
            appName: '会员管理',
            operModule: '编辑会员系统设置',
        },
    });
}
//数据项排序
export function dragAndDrop(params,data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberFormItem/dragAndDrop',
        method: 'post',
        dataType: 'json',
        params,
        data,        
    });
}
//自定义项数据项名称重复校验
export function checkItemName(data,params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberFormItem/checkItemName',
        method: 'post',
        dataType: 'json',
        params,
        data,
    });
}
//导入明细
export function getImportDetailList(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberImport/getImportDetailList',
        method: 'get',
        params,
    });
}
//查看失败详情
export function getFailDetailList(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberImport/getFailDetailList',
        method: 'get',
        params,
    });
}
//导出校验
export function checkExportMember(data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberImport/checkExpoortMember',
        method: 'post',
        dataType: 'json',
        data,
    });
}
//会员修改密码
export function editPwd(params,data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/editPwd',
        method: 'post',
        dataType: 'json',
        data,
        params,
    });
}
/**
 * 
 跟进记录列表
 */
export function memberFollowupRecord(params,data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberFollowupRecord/findList',
        method: 'post',
        dataType: 'json',
        params,
        data,
    });
}
/**
 * 
 添加跟进记录
 */
export function addMemberFollowupRecord(params,data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberFollowupRecord/add',
        method: 'post',
        dataType: 'json',
        params,
        data,
    });
}

export function listTenantByUserCodeAndAppCode(params) {
    return request({
        url: '{#npgw}/common-layer/userTenantPermission/listTenantByUserCodeAndAppCode',
        method: 'get',
        params,
    }).then(filterHiddenTenants);
}

/**
 * 根据多个客户分组查客户列表
 */

export function listMemberInfoByGroupIds(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberInfo/listMemberInfoByGroupIds',
        method: 'get',
        params,
    });
}
/**
 * 查询会员等级折扣计算规则
 */
export function getMemberAmountDigitRule(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberLevel/getMemberAmountDigitRule',
        method: 'get',
        params,
    });
}
/**
 * 查询会员等级折扣
 */
export function getMemberLevelDiscountList(params) {
    return request({
        url: '{#npgw}/mwebapi/member/memberLevel/getMemberLevelDiscountList',
        method: 'get',
        params,
    });
}

/**
 * 
 启用禁用会员折扣
 */
export function updateEnablerDiscount(data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberLevel/updateEnablerDiscount',
        method: 'post',
        dataType: 'json',
        data,
    });
} 
/**
 * 
 修改会员折扣和计算规则
 */
export function updateMemberLevelDiscount(data) {
    return request({
        url: '{#npgw}/mwebapi/member/memberLevel/updateMemberLevelDiscount',
        method: 'post',
        dataType: 'json',
        data,
    });
}